import { render, staticRenderFns } from "./ClientsNotebookList.vue?vue&type=template&id=13cce7a6"
import script from "./ClientsNotebookList.vue?vue&type=script&lang=js"
export * from "./ClientsNotebookList.vue?vue&type=script&lang=js"
import style0 from "./ClientsNotebookList.vue?vue&type=style&index=0&id=13cce7a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports